module.exports = __webpack_public_path__ + "static/media/JW-marriot05.9d9b7609.jpg";